import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"

const FlexWrap = styled(Flex)`
  flex-direction: column;
  padding: 40px 16px;
  margin: 0 auto;
  width: 100%;

  li {
    list-style: outside !important;
    padding-bottom: 20px;
    font-weight: bold;

    sup {
      font-size: 50%;
      letter-spacing: 1px;
      top: -1em;
    }
  }

  @media (min-width: 768px) {
    padding: 40px;
  }
  @media (min-width: 1280px) {
    flex-direction: row;
  }
`

const ImgBox = styled(Box)`
  img {
    margin: 0 auto;
    width: 100%;
    max-width: 313px;
    @media (min-width: 1280px) {
      max-width: 235px;
    }
  }
`

const BulletsBox = styled(Box)`
  li {
    color: #fff;
    font-size: 14px;
    line-height: 19.2px;
    @media (min-width: 1600px) {
      font-size: 18px;
      line-height: 25.2px;
    }
  }
`

const ComparisonCard = ({ data }) => {
  const { title, mobileImage, desktopImage, bullets } = data

  let bulletstrim = bullets?.trim()

  if (!bulletstrim) {
    return null
  }

  return (
    <FlexWrap>
      <Box className={`show-xlg-up`} width={[235]}>
        <ImgBox>
          <img src={desktopImage} alt={``} role={`presentation`} />
        </ImgBox>
      </Box>
      <Box width={[1]} flex={1}>
        <Box width={[1]}>
          <TextElementMen
            element="h2"
            text={title}
            className={"title--medium text-men-base-default text-center"}
          />
        </Box>
        <ImgBox className={`hide-xlg-up`} py={[16]}>
          <img src={mobileImage} alt={``} role={`presentation`} />
        </ImgBox>
        <Box width={[1]} px={[16, 16, 40, 40]} pt={[0, 0, 0, 0, 80]}>
          {/* this causes hydration errors
          <TextElementMen*/}
          {/*  element="p"*/}
          {/*  text={bulletstrim}*/}
          {/*  className={"body--regular text-men-base-default"}*/}
          {/*/>*/}
          <BulletsBox
            className={`font-dinamoBold`}
            dangerouslySetInnerHTML={{ __html: bulletstrim }}
          ></BulletsBox>
        </Box>
      </Box>
    </FlexWrap>
  )
}

export default ComparisonCard
